const userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent;

const isIPadOS =
  typeof navigator !== 'undefined' &&
  navigator.platform === 'MacIntel' &&
  navigator.maxTouchPoints > 1;

const isTablet =
  isIPadOS ||
  /iPad|Tablet|PlayBook|Silk|Kindle|Android(?!.*Mobi)/i.test(userAgent);

export const isMobileOnly =
  !isTablet &&
  /Mobi|iPhone|iPod|Android|Windows Phone|BlackBerry|BB10|Opera Mini|IEMobile/i.test(
    userAgent
  );

export const isDesktop = !isTablet && !isMobileOnly;
